import { ThemeOptions } from "@mui/material";

export const formHelperTextOverrides: ThemeOptions["components"] = {
	MuiFormHelperText: {
		styleOverrides: {
			root: {
				fontSize: "14px",
			},
		},
	},
};
